export enum PeriodType {
    Day = 1,
    Week = 2,
    Month = 3,
    Year = 4,
}

export const enumLabel = (value: PeriodType) => {
    switch (value) {
        case PeriodType.Day:
            return 'День';
        case PeriodType.Week:
            return 'Неделя';
        case PeriodType.Month:
            return 'Месяц';
        case PeriodType.Year:
            return 'Год';

        default:
            return '';
    }
};
